let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7juzI")).then(() => parcelRequire('esTj4'));